export async function copyPlain(text) {
  const t = text || '';
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(t).then(
      () => {
        return true;
      },
      () => {
        return fallbackCopy(t);
      },
    );
  } else {
    return fallbackCopy(t);
  }
}

export function fallbackCopy(text) {
  const ta = document.createElement('textarea');
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
  } catch (e) {
    console.error('Error while copying text:', e);
  }
  document.body.removeChild(ta);
}

export async function copyImage(src) {
  try {
    const response = await fetch(src);
    const blob = await response.blob();

    const pngBlob = await convertToPng(blob);
    const clipboardItem = new window.ClipboardItem({
      'image/png': pngBlob,
    });
    await navigator.clipboard.write([clipboardItem]);
    return true;
  } catch (error) {
    console.error('Error while copying image:', error);
    return false;
  }
}

export function convertToPng(blob) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(pngBlob => {
        if (pngBlob) resolve(pngBlob);
        else reject(new Error('Failed to convert image to PNG'));
      }, 'image/png');
    };
    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(blob);
  });
}

export function isVideoUrl(urlStr) {
  const VIDEO_EXT_RE = /\.(mp4|webm|mov|m4v|avi|ogv|ogg)(\?|#|$)/i;

  try {
    return VIDEO_EXT_RE.test(new URL(urlStr).pathname);
  } catch {
    return VIDEO_EXT_RE.test(String(urlStr || ''));
  }
}

const DISALLOWED_IMAGE_EXT_RE = /\.(gif|bmp|svg|ico|avif|heic|heif|tiff?)(\?|#|$)/i;
const ALLOWED_IMAGE_EXT_RE = /\.(png|jpe?g|webp)(\?|#|$)/i;

function imageUrlPathname(urlStr) {
  const s = String(urlStr || '').trim();
  if (!s) return '';
  try {
    return new URL(s).pathname;
  } catch {
    return s.split(/[?#]/)[0] || s;
  }
}

export function isDisallowedImageUrl(urlStr) {
  return DISALLOWED_IMAGE_EXT_RE.test(imageUrlPathname(urlStr));
}

export function isAllowedImageUrl(urlStr) {
  const pathname = imageUrlPathname(urlStr);
  if (!pathname || isDisallowedImageUrl(urlStr)) return false;
  return ALLOWED_IMAGE_EXT_RE.test(pathname);
}

export function filenameFromMediaUrl(urlStr, isVideo) {
  try {
    const pathname = new URL(urlStr).pathname;
    const base = pathname
      .split('/')
      .filter(Boolean)
      .pop();
    if (base) {
      const decoded = decodeURIComponent(base);
      if (/\.(png|jpe?g|webp)$/i.test(decoded)) return decoded;
      if (/\.(mp4|webm|mov|m4v|avi|ogv|ogg)$/i.test(decoded)) return decoded;
    }
  } catch {
    /* ignore */
  }
  return isVideo ? 'video-from-url.mp4' : 'image-from-url.png';
}
